import axios from "axios";


const mutations = {
};
const state = {
};
const getters = {
};
const actions = {
  sendApplicationForm({commit}, form){
    return axios
      .post("/api/panelApplication/applicationForm", form)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};